import styled from '@emotion/styled';

import { FindAContractorConnector } from '../../redux/connectors/FindAContractorConnector';
import LocationModalOpener from '../LocationModalOpener';
import { If } from '../Utilities';
import { connectLocation } from '../location/LocationConnectors';

const Wrapper = styled.div`
  display: flex;
`;

const LocationWrapper = styled.span`
  white-space: nowrap;
`;

function summaryText({ city, count, invalidZip, maxDistance, region, t }) {
  if (invalidZip) return t('contractors.contractors_summary.zip_not_recognized');
  if (count === 0) return t('contractors.contractors_summary.zero_results', { maxDistance, city, region });

  // Get the base text without the location
  const baseText = t('contractors.independent_roofing_contractors', { count, location: '' }).trim();

  // If there are multiple contractors, return the text
  if (count !== 1) return baseText;

  // If there is one contractor, convert "Contractors" to "Contractor"
  return baseText.replace(
    new RegExp(`/${t('contractors.contractors_summary.contractors')}/i`),
    t('contractors.contractors_summary.contractor')
  );
}

function localizedDistance({ maxDistance, t }) {
  switch (parseInt(maxDistance)) {
    case 20:
      return t('contractors.max_distance.option_1');
    case 50:
      return t('contractors.max_distance.option_2');
    case 100:
      return t('contractors.max_distance.option_3');
    default:
      return maxDistance;
  }
}

// city, filteredContractorsCount, invalidZip, maxDistance, region from FindAContractorConnector
// t from connectLocation
const LocationContractorsSummary = ({ bot, city, filteredContractorsCount, invalidZip, maxDistance, region, t }) => (
  <Wrapper>
    <h2 className="body-font h3 results-info fac-location-summary">
      <span>
        {summaryText({
          city,
          count: filteredContractorsCount,
          invalidZip,
          maxDistance: localizedDistance({ maxDistance, t }),
            region,
            t,
        })}
      </span>
      <LocationWrapper>
        {' '}
        {city}, {region}
        <If condition={!bot}>
          {' '}
          <LocationModalOpener ariaLabel="change zipcode" dataTrack="change-zip-open" text={t('contractors.change')} />
        </If>
      </LocationWrapper>
    </h2>
  </Wrapper>
);

export default FindAContractorConnector(connectLocation(LocationContractorsSummary));
